import { render, staticRenderFns } from "./Perkville.vue?vue&type=template&id=f462579e"
import script from "./Perkville.vue?vue&type=script&lang=js"
export * from "./Perkville.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports